import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserFull = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.6518 17.6555C17.2046 17.5403 17.5338 16.9618 17.2591 16.4684C16.6535 15.3808 15.6995 14.425 14.4791 13.6966C12.9073 12.7586 10.9814 12.2501 9.00022 12.2501C7.01901 12.2501 5.09316 12.7586 3.52137 13.6966C2.30093 14.425 1.34691 15.3808 0.741325 16.4684C0.466627 16.9618 0.795863 17.5403 1.34868 17.6555C6.39549 18.7073 11.6049 18.7073 16.6518 17.6555Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.0002 5.25012C14.0002 8.01155 11.7616 10.2501 9.00022 10.2501C6.23879 10.2501 4.00022 8.01155 4.00022 5.25012C4.00022 2.4887 6.23879 0.250122 9.00022 0.250122C11.7616 0.250122 14.0002 2.4887 14.0002 5.25012Z",
		fill: "currentColor"
	})]
});
export default SvgUserFull;
